export const STIVISTO_NAME = "Stivisto Inc.";
export const STIVISTO_ADDRESS = "701 West Georgia Street, Suite 1500,\n" +
        "Vancouver, BC\n" +
        "Canada V7Y 1C6";
